import { render, staticRenderFns } from "./IconCloseModal.vue?vue&type=template&id=1350c0db&"
import script from "./IconCloseModal.vue?vue&type=script&lang=js&"
export * from "./IconCloseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1350c0db')) {
      api.createRecord('1350c0db', component.options)
    } else {
      api.reload('1350c0db', component.options)
    }
    module.hot.accept("./IconCloseModal.vue?vue&type=template&id=1350c0db&", function () {
      api.rerender('1350c0db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconCloseModal.vue"
export default component.exports